export const cra = {
  month: "Month",
  year: "Year",
  totalProduction: "Total Production",
  totalAbsences: "Total Absences",
  status: "Status",
  createdAt: "Created At",
  pending: "Pending Validation",
  validated: "Validated",
  title_edit: "CRA Details",
  collaborator: "collaborator",
  actions: {
    view: "View",
    validate: "Validate",
  },
  messages: {
    validated: "CRA successfully validated",
    validate_error: "Error validating CRA",
  },
  title: "Timesheets",
  column_period: "Period",
  column_status: "Status",
  status_draft: "Draft",
  status_pending_validation: "Pending validation",
  status_validated: "Validated",
  status_refused: "Refused",
  status_pending: "Pending",
  loading: "Loading...",
  header_title: "Timesheet Overview",
};
